(ns ui.data.query-results.event
  (:require
   [re-frame.core :as rf]))

(def root-path [:ui.data/query-results])

(defn- compare-pr-str
  [a b]
  (compare (pr-str a) (pr-str b)))

(defn canonicalize
  [x]
  (cond
    (map? x)
    (into (sorted-map-by compare-pr-str)
          (map (fn [[k v]]
                 [(canonicalize k) (canonicalize v)]))
          x)

    (set? x)
    (->> x
         (map canonicalize)
         (sort-by pr-str)
         vec)

    (sequential? x)
    (mapv canonicalize x)

    :else
    x))

(defn request->query-key
  [{:keys [source request]}]
  (pr-str (canonicalize {:source source
                         :request request})))

(defn- entry-path
  [query-key]
  (into root-path [query-key]))

(defn- default-status
  [phase]
  {:phase phase
   :error-code nil
   :error-message nil
   :last-request-at nil
   :last-success-at nil})

(defn- default-entry
  [query-key]
  {:query-key query-key
   :source nil
   :request nil
   :refresh-event nil
   :stale? false
   :status (default-status :idle)
   :result nil})

(defn ensure-query-result
  [db query-key]
  (if (get-in db (entry-path query-key))
    db
    (assoc-in db (entry-path query-key) (default-entry query-key))))

(defn record-loading
  [db query-key {:keys [source request refresh-event]}]
  (let [now (.now js/Date)]
    (-> db
        (ensure-query-result query-key)
        (assoc-in (entry-path query-key)
                  (merge (default-entry query-key)
                         (get-in db (entry-path query-key))
                         {:source source
                          :request request
                          :refresh-event refresh-event
                          :stale? false
                          :status {:phase :loading
                                   :error-code nil
                                   :error-message nil
                                   :last-request-at now
                                   :last-success-at (get-in db (into (entry-path query-key) [:status :last-success-at]))}})))))

(defn record-result
  [db query-key {:keys [source request refresh-event rows total facets raw result-meta]}]
  (let [now (.now js/Date)
        result (merge {:rows rows
                       :total total
                       :facets facets
                       :raw raw}
                      (when result-meta {:meta result-meta}))]
    (-> db
        (ensure-query-result query-key)
        (assoc-in (entry-path query-key)
                  (merge (default-entry query-key)
                         (get-in db (entry-path query-key))
                         {:source source
                          :request request
                          :refresh-event refresh-event
                          :stale? false
                          :status {:phase :ready
                                   :error-code nil
                                   :error-message nil
                                   :last-request-at (get-in db (into (entry-path query-key) [:status :last-request-at]))
                                   :last-success-at now}
                          :result result})))))

(defn record-error
  [db query-key error]
  (let [message (cond
                  (string? error) error
                  (map? error) (or (:message error)
                                   (:error error)
                                   (pr-str error))
                  :else (pr-str error))]
    (-> db
        (ensure-query-result query-key)
        (assoc-in (entry-path query-key)
                  (merge (default-entry query-key)
                         (get-in db (entry-path query-key))
                         {:stale? false
                          :status {:phase :error
                                   :error-code nil
                                   :error-message message
                                   :last-request-at (get-in db (into (entry-path query-key) [:status :last-request-at]))
                                   :last-success-at (get-in db (into (entry-path query-key) [:status :last-success-at]))}})))))

(defn mark-stale
  [db query-key]
  (-> db
      (ensure-query-result query-key)
      (assoc-in (conj (entry-path query-key) :stale?) true)
      (assoc-in (conj (entry-path query-key) :status :phase) :stale)))

(rf/reg-event-fx
 ::refresh-query-result
 (fn [{:keys [db]} [_ query-key]]
   (let [refresh-event (get-in db (into (entry-path query-key) [:refresh-event]))]
     (cond-> {:db (mark-stale db query-key)}
       refresh-event (assoc :dispatch refresh-event)))))
